<template>
  <div @click="showPhotos(item.type,item)" class="cursor-pointer">
    <div class="h-40 lg:h-44 relative justify-self-stretch">
      <div  class="inset-0 rounded-item overflow-hidden shadow-item group">
        <img  v-if="thumb && !hasVideo" :src="thumb" :alt="item.name" class="absolute w-full h-full object-cover rounded-item">
        <template v-if="hasVideo">
          <img v-if="gifFile" :src="gifFile" class="absolute w-full h-full object-cover rounded-item opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <video
            v-else
            class="absolute w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-item"
            @mouseleave="stop($event)"
            @mouseenter="play($event)"
            muted
            loop
          >
            <source :src="videoFile.url" :type="videoFile.mime_type && videoFile.mime_type !== 'video/quicktime' ? videoFile.mime_type : 'video/mp4'">
            Your browser does not support the video tag.
          </video>

          <img :src="item.previews[0] || item.previewImg" class="absolute w-full h-full object-cover opacity-100 group-hover:opacity-0 transition-opacity duration-200 rounded-item">
        </template>
      </div>
    </div>
    <div class="pt-3">
      <div class="flex items-center justify-between">
        <h4 class="font-semibold w-32 2xl:text-lg truncate" :title="item.name">{{ item.name | truncate(item.type === 'video' ? 36 : 21, '..') }}</h4>
      </div>
      <p class="text-payneFire text-sm font-light truncate capitalize">{{ item.type}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PostItem',

  props: {
    item:{
      type:Object,
      require:true
    } ,
  },

  computed: {
    gifFile() {
      return this.item.previewGif || null;
    },
    videoFile() {
      return this.item.files.find(file => file.mime_type.startsWith('video/'));
    },
    hasVideo() {
      return !! this.videoFile;
    },
    thumb() {
      if (this.item.previewImg) {
        return this.item.previewImg;
      }
      if (!this.item.previews.length) {
        return;
      }
      return this.item.previews[0];
    },
  },
  
  methods: {
    play(event) {
      event.target.play();
    },
    stop(event) {
      event.target.pause();
    },
    showPhotos(show, item){
      this.$emit('clicked', {'show': show, 'item':item});
    }
  }
}
</script>